import { CPMSessionSummary } from './CPMSessionSummary.js';
import { OrderDetail } from './OrderDetail.js';
import { CPMSessionDaily } from './CPMSessionDaily.js';
import { DoctorKneeProtocol } from './DoctorKneeProtocol.js';
import { PhysicianPortalEvents } from './PhysicianPortalEvents.js';
import { PainResponses } from './PainResponses.js';
import { ExerciseResponses } from './ExerciseResponses.js';
import { WalkResponses } from './WalkResponses.js';
import { SatisfactionResponses } from './SatisfactionResponses.js';
import { TriggeredEvents } from './TriggeredEvents.js';

const _summary = Symbol();
const _orderDetail = Symbol();
const _cpmSessionDaily = Symbol();
const _doctorKneeProtocol = Symbol();
const _physicianPortalEvents = Symbol();
const _painResponses = Symbol();
const _exerciseResponses = Symbol();
const _walkResponses = Symbol();
const _satisfactionResponses = Symbol();
const _triggeredEvents = Symbol();

export const PATIENT_PAIN_SURVEY_ANSWER_0 = 10001;
export const PATIENT_PAIN_SURVEY_ANSWER_1 = 10002;
export const PATIENT_PAIN_SURVEY_ANSWER_2 = 10003;
export const PATIENT_PAIN_SURVEY_ANSWER_3 = 10004;
export const PATIENT_PAIN_SURVEY_ANSWER_4 = 10005;
export const PATIENT_PAIN_SURVEY_ANSWER_5 = 10006;
export const PATIENT_PAIN_SURVEY_ANSWER_6 = 10007;
export const PATIENT_PAIN_SURVEY_ANSWER_7 = 10008;
export const PATIENT_PAIN_SURVEY_ANSWER_8 = 10009;
export const PATIENT_PAIN_SURVEY_ANSWER_9 = 10010;
export const PATIENT_PAIN_SURVEY_ANSWER_10 = 10011;
export const PATIENT_PAIN_SURVEY_ANSWERS = {
	PATIENT_PAIN_SURVEY_ANSWER_10,
	PATIENT_PAIN_SURVEY_ANSWER_9,
	PATIENT_PAIN_SURVEY_ANSWER_8,
	PATIENT_PAIN_SURVEY_ANSWER_7,
	PATIENT_PAIN_SURVEY_ANSWER_6,
	PATIENT_PAIN_SURVEY_ANSWER_5,
	PATIENT_PAIN_SURVEY_ANSWER_4,
	PATIENT_PAIN_SURVEY_ANSWER_3,
	PATIENT_PAIN_SURVEY_ANSWER_2,
	PATIENT_PAIN_SURVEY_ANSWER_1,
	PATIENT_PAIN_SURVEY_ANSWER_0
};
export const PATIENT_PAIN_SURVEY_ANSWER_VALUES = {
	[PATIENT_PAIN_SURVEY_ANSWER_10]: 10,
	[PATIENT_PAIN_SURVEY_ANSWER_9]: 9,
	[PATIENT_PAIN_SURVEY_ANSWER_8]: 8,
	[PATIENT_PAIN_SURVEY_ANSWER_7]: 7,
	[PATIENT_PAIN_SURVEY_ANSWER_6]: 6,
	[PATIENT_PAIN_SURVEY_ANSWER_5]: 5,
	[PATIENT_PAIN_SURVEY_ANSWER_4]: 4,
	[PATIENT_PAIN_SURVEY_ANSWER_3]: 3,
	[PATIENT_PAIN_SURVEY_ANSWER_2]: 2,
	[PATIENT_PAIN_SURVEY_ANSWER_1]: 1,
	[PATIENT_PAIN_SURVEY_ANSWER_0]: 0
};

export const PATIENT_EXERCISE_SURVEY_ANSWER_NONE = 10020;
export const PATIENT_EXERCISE_SURVEY_ANSWER_15 = 10021;
export const PATIENT_EXERCISE_SURVEY_ANSWER_30 = 10022;
export const PATIENT_EXERCISE_SURVEY_ANSWER_45 = 10023;
export const PATIENT_EXERCISE_SURVEY_ANSWER_60 = 10024;
export const PATIENT_EXERCISE_SURVEY_ANSWER_90 = 10025;
export const PATIENT_EXERCISE_SURVEY_ANSWER_120 = 10026;
export const PATIENT_EXERCISE_SURVEY_ANSWERS = {
	PATIENT_EXERCISE_SURVEY_ANSWER_NONE,
	PATIENT_EXERCISE_SURVEY_ANSWER_15,
	PATIENT_EXERCISE_SURVEY_ANSWER_30,
	PATIENT_EXERCISE_SURVEY_ANSWER_45,
	PATIENT_EXERCISE_SURVEY_ANSWER_60,
	PATIENT_EXERCISE_SURVEY_ANSWER_90,
	PATIENT_EXERCISE_SURVEY_ANSWER_120
};
export const PATIENT_EXERCISE_SURVEY_ANSWER_VALUES = {
	[PATIENT_EXERCISE_SURVEY_ANSWER_NONE]: 0,
	[PATIENT_EXERCISE_SURVEY_ANSWER_15]: 15 * 60,
	[PATIENT_EXERCISE_SURVEY_ANSWER_30]: 30 * 60,
	[PATIENT_EXERCISE_SURVEY_ANSWER_45]: 45 * 60,
	[PATIENT_EXERCISE_SURVEY_ANSWER_60]: 60 * 60,
	[PATIENT_EXERCISE_SURVEY_ANSWER_90]: 90 * 60,
	[PATIENT_EXERCISE_SURVEY_ANSWER_120]: 120 * 60
};
export const PATIENT_WALK_SURVEY_ANSWER_NONE = 10036;
export const PATIENT_WALK_SURVEY_ANSWER_15 = 10037;
export const PATIENT_WALK_SURVEY_ANSWER_30 = 10038;
export const PATIENT_WALK_SURVEY_ANSWER_45 = 10039;
export const PATIENT_WALK_SURVEY_ANSWER_60 = 10040;
export const PATIENT_WALK_SURVEY_ANSWER_90 = 10041;
export const PATIENT_WALK_SURVEY_ANSWER_120 = 10042;
export const PATIENT_WALK_SURVEY_ANSWERS = {
	PATIENT_WALK_SURVEY_ANSWER_NONE,
	PATIENT_WALK_SURVEY_ANSWER_15,
	PATIENT_WALK_SURVEY_ANSWER_30,
	PATIENT_WALK_SURVEY_ANSWER_45,
	PATIENT_WALK_SURVEY_ANSWER_60,
	PATIENT_WALK_SURVEY_ANSWER_90,
	PATIENT_WALK_SURVEY_ANSWER_120
};
export const PATIENT_WALK_SURVEY_ANSWER_VALUES = {
	[PATIENT_WALK_SURVEY_ANSWER_NONE]: 0 * 60,
	[PATIENT_WALK_SURVEY_ANSWER_15]: 15 * 60,
	[PATIENT_WALK_SURVEY_ANSWER_30]: 30 * 60,
	[PATIENT_WALK_SURVEY_ANSWER_45]: 45 * 60,
	[PATIENT_WALK_SURVEY_ANSWER_60]: 60 * 60,
	[PATIENT_WALK_SURVEY_ANSWER_90]: 90 * 60,
	[PATIENT_WALK_SURVEY_ANSWER_120]: 120 * 60
};
export const PATIENT_SATISFACTION_SURVEY_ANSWER_1 = 10027;
export const PATIENT_SATISFACTION_SURVEY_ANSWER_2 = 10028;
export const PATIENT_SATISFACTION_SURVEY_ANSWER_3 = 10029;
export const PATIENT_SATISFACTION_SURVEY_ANSWER_4 = 10030;
export const PATIENT_SATISFACTION_SURVEY_ANSWER_5 = 10031;
export const PATIENT_SATISFACTION_SURVEY_ANSWERS = {
	PATIENT_SATISFACTION_SURVEY_ANSWER_1,
	PATIENT_SATISFACTION_SURVEY_ANSWER_2,
	PATIENT_SATISFACTION_SURVEY_ANSWER_3,
	PATIENT_SATISFACTION_SURVEY_ANSWER_4,
	PATIENT_SATISFACTION_SURVEY_ANSWER_5
};
export const PATIENT_SATISFACTION_SURVEY_ANSWER_VALUES = {
	[PATIENT_SATISFACTION_SURVEY_ANSWER_1]: 1,
	[PATIENT_SATISFACTION_SURVEY_ANSWER_2]: 2,
	[PATIENT_SATISFACTION_SURVEY_ANSWER_3]: 3,
	[PATIENT_SATISFACTION_SURVEY_ANSWER_4]: 4,
	[PATIENT_SATISFACTION_SURVEY_ANSWER_5]: 5
};

export class PatientProgressData {
	constructor(orderDetail, summary, cpmSessionDaily, doctorKneeProtocol, physicianPortalEvents, painResponses, exerciseResponses, walkResponses, satisfactionResponses, triggeredEvents) {
		this.orderDetail = orderDetail;
		this.summary = summary;
		this.cpmSessionDaily = cpmSessionDaily;
		this.doctorKneeProtocol = doctorKneeProtocol;
		this.physicianPortalEvents = physicianPortalEvents;
		this.painResponses = painResponses;
		this.exerciseResponses = exerciseResponses;
		this.walkResponses = walkResponses;
		this.satisfactionResponses = satisfactionResponses;
		this.triggeredEvents = triggeredEvents;
	}
	get orderDetail() {
		return this[_orderDetail];
	}
	set orderDetail(v) {
		if(!(v instanceof OrderDetail))
			throw new TypeError('orderDetail must be an instance of OrderDetail.');
		this[_orderDetail] = v;
	}
	get summary() {
		return this[_summary];
	}
	set summary(v) {
		if(!(v instanceof CPMSessionSummary))
			throw new TypeError('summary must be an instance of CPMSessionSummary.');
		this[_summary] = v;
	}
	get cpmSessionDaily() {
		return this[_cpmSessionDaily];
	}
	set cpmSessionDaily(v) {
		if(!(v instanceof CPMSessionDaily))
			throw new TypeError('cpmSessionDaily must be an instance of CPMSessionDaily.');
		this[_cpmSessionDaily] = v;
	}
	get doctorKneeProtocol() {
		return this[_doctorKneeProtocol];
	}
	set doctorKneeProtocol(v) {
		if(v !== null && !(v instanceof DoctorKneeProtocol))
			throw new TypeError('doctorKneeProtocol must be an instance of DoctorKneeProtocol.');
		this[_doctorKneeProtocol] = v;
	}
	get physicianPortalEvents() {
		return this[_physicianPortalEvents];
	}
	set physicianPortalEvents(v) {
		if(!(v instanceof PhysicianPortalEvents))
			throw new TypeError('physicianPortalEvents must be an instance of PhysicianPortalEvents.');
		this[_physicianPortalEvents] = v;
	}
	get painResponses() {
		return this[_painResponses];
	}
	set painResponses(v) {
		if(!(v instanceof PainResponses))
			throw new TypeError('painResponses must be an instance of PainResponses.');
		this[_painResponses] = v;
	}
	get exerciseResponses() {
		return this[_exerciseResponses];
	}
	set exerciseResponses(v) {
		if(!(v instanceof ExerciseResponses))
			throw new TypeError('exerciseResponses must be an instance of ExerciseResponses.');
		this[_exerciseResponses] = v;
	}
	get walkResponses() {
		return this[_walkResponses];
	}
	set walkResponses(v) {
		if(!(v instanceof WalkResponses))
			throw new TypeError('walkResponses must be an instance of WalkResponses.');
		this[_walkResponses] = v;
	}
	get satisfactionResponses() {
		return this[_satisfactionResponses];
	}
	set satisfactionResponses(v) {
		if(!(v instanceof SatisfactionResponses))
			throw new TypeError('satisfactionResponses must be an instance of SatisfactionResponses.');
		this[_satisfactionResponses] = v;
	}
	get triggeredEvents() {
		return this[_triggeredEvents];
	}
	set triggeredEvents(v) {
		if(!(v instanceof TriggeredEvents))
			throw new TypeError('triggeredEvents must be an instance of TriggeredEvents.');
		this[_triggeredEvents] = v;
	}
	get firstDay() {
		return this.orderDetail.surgeryDate;
	}
	get lastDay() {
		let days = [this.orderDetail.surgeryDate];
		if(this.cpmSessionDaily.lastDay)
			days.push(this.cpmSessionDaily.lastDay.usageDate);
		if(this.painResponses.lastDay)
			days.push(this.painResponses.lastDay.answerDate);
		if(this.exerciseResponses.lastDay)
			days.push(this.exerciseResponses.lastDay.answerDate);
		if(this.walkResponses.lastDay)
			days.push(this.walkResponses.lastDay.answerDate);
		if(this.satisfactionResponses.lastDay)
			days.push(this.satisfactionResponses.lastDay.answerDate);
		
		return days.reduce((p, c) => {
			if(p === null || p < c)
				return c;
			return p;
		}, null);
	}
	toJSON() {
		return {
			orderDetail: this.orderDetail,
			summary: this.summary,
			cpmSessionDaily: this.cpmSessionDaily,
			doctorKneeProtocol: this.doctorKneeProtocol,
			physicianPortalEvents: this.physicianPortalEvents,
			painResponses: this.painResponses,
			exerciseResponses: this.exerciseResponses,
			walkResponses: this.walkResponses,
			satisfactionResponses: this.satisfactionResponses,
			triggeredEvents: this.triggeredEvents
		};
	}
	static fromObject(obj) {
		if(obj === null || typeof obj !== 'object')
			throw new TypeError('obj must be an object.');
		return new this(
			OrderDetail.fromObject(obj.orderDetail),
			CPMSessionSummary.fromObject(obj.summary),
			CPMSessionDaily.fromArray(obj.cpmSessionDaily),
			obj.doctorKneeProtocol ? DoctorKneeProtocol.fromObject(obj.doctorKneeProtocol) : null,
			PhysicianPortalEvents.fromArray(obj.physicianPortalEvents),
			PainResponses.fromArray(obj.painResponses),
			ExerciseResponses.fromArray(obj.exerciseResponses),
			WalkResponses.fromArray(obj.walkResponses),
			SatisfactionResponses.fromArray(obj.satisfactionResponses),
			TriggeredEvents.fromArray(obj.triggeredEvents)
		);
	}
}